export const Circles = () => (
  <svg width="1356" height="1356" viewBox="0 0 1356 1356" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.4">
      <circle opacity="0.9" cx="678" cy="678" r="152.097" stroke="white" strokeWidth="2" />
      <circle opacity="0.8" cx="678" cy="678" r="217.71" stroke="white" strokeWidth="2" />
      <circle opacity="0.7" cx="678" cy="678" r="283.323" stroke="white" strokeWidth="2" />
      <circle opacity="0.6" cx="678" cy="678" r="348.935" stroke="white" strokeWidth="2" />
      <circle opacity="0.5" cx="678" cy="678" r="414.548" stroke="white" strokeWidth="2" />
      <circle opacity="0.4" cx="678" cy="678" r="480.161" stroke="white" strokeWidth="2" />
      <circle opacity="0.3" cx="678" cy="678" r="545.774" stroke="white" strokeWidth="2" />
      <circle opacity="0.2" cx="678" cy="678" r="611.387" stroke="white" strokeWidth="2" />
      <circle opacity="0.1" cx="678" cy="678" r="677" stroke="white" strokeWidth="2" />
    </g>
  </svg>
);

export default undefined;
